// Core
import PropTypes from "prop-types";

// Components
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

// Images
import logoV1 from "assets/images/logo/Recreation_Logotipo vetorizado_V1_COLOR.svg";
import logoV2 from "assets/images/logo/Recreation_Logotipo vetorizado_V2_COLOR.svg";
import logoV1MonoWhite from "assets/images/Recreation_Logotipo vetorizado_V1_MONO WHT.svg";
import logoV2MonoWhite from "assets/images/Recreation_Logotipo vetorizado_V2_MONO WHT.svg";

function Logo({ size = "medium", showSubtitle = false, align = "center", variant = "v1" }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  // Size variants - heights for the logo image
  const sizes = {
    small: "90px", // Used in Sidenav/menu (increased from 90px)
    medium: "150px", // Used in auth pages
    large: "200px",
  };

  // Logo variants — use white mono versions in dark mode
  const logos = {
    v1: isDark ? logoV1MonoWhite : logoV1, // For authentication pages
    v2: isDark ? logoV2MonoWhite : logoV2, // For sidenav menu
  };

  const height = sizes[size] || sizes.medium;
  const justifyContent = align === "left" ? "flex-start" : "center";
  const logoSrc = logos[variant] || logos.v1;

  return (
    <Box textAlign={align}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent={justifyContent}
        mb={showSubtitle ? 1 : 0}
      >
        <img
          src={logoSrc}
          alt="RECreation Logo"
          style={{
            height,
            width: "auto",
            display: "block",
          }}
        />
      </Box>
    </Box>
  );
}

Logo.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  showSubtitle: PropTypes.bool,
  align: PropTypes.oneOf(["left", "center"]),
  variant: PropTypes.oneOf(["v1", "v2"]),
};

Logo.defaultProps = {
  size: "medium",
  showSubtitle: false,
  align: "center",
  variant: "v1",
};

export default Logo;
